export const NoEvents = ({ className }: { className?: string }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path
      d="M43.5557 54.8733H17.0971C16.6689 54.4451 16.4286 54.2047 16 53.7761V41.5994C16.1075 41.3347 16.2029 41.0994 16.3104 40.8347L19.7014 37.3458V35.8165L17.2061 33.249C17.3932 32.4665 17.45 32.2294 17.6371 31.4465L26.3075 28.4729V26.3972L17.6371 23.4233C17.45 22.6408 17.3932 22.4036 17.2061 21.6208L19.7014 19.0533V17.5244L16.3104 14.0351C16.2029 13.7704 16.1075 13.5351 16 13.2704V10.2397C16.4268 9.81329 16.6704 9.56936 17.0971 9.14258H38.6475C38.9439 9.14258 39.2279 9.26258 39.4343 9.47508L47.6896 17.9694C47.7971 18.234 47.8925 18.4697 48 18.7344V31.3386C47.7861 31.6894 47.6189 31.9633 47.405 32.3144L41.0075 35.6054V37.5565L46.6825 40.4765C46.8018 41.2036 46.8486 41.4894 46.9675 42.2165L44.2986 44.9626V46.4919L47.6896 49.9808C47.7971 50.2454 47.8925 50.4811 48 50.7458V53.7761C47.5732 54.2029 47.3296 54.4465 46.9029 54.8733H43.5557Z"
      fill="#B2ABAB"
    />
  </svg>
);
